export default '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m20 8.49976v3.00004h-20v-3.00004z" fill="currentColor"/></svg>';
export const title = "interface-remove-small";
export const tags =
  "nordicon interface remove small delete erase minimize line minus sign";
